<template>
  <main class="main" role="main">
    <div class="page grey">
      <!--'로그인, 아이디찾기, 비밀번호찾기: grey'-->
      <div class="inner">
        <div class="page_ttl">
          <h1 class="h1">
            <span>로그인</span>
          </h1>
        </div>
        <div class="page_con">
          <!--로그인-->
          <sign-in :is-page="true" />
          <!--//로그인-->
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import SignIn from '@/components/pages/sign/in/index'

export default {
  name: 'sign-in-index',
  components: { SignIn }
}
</script>

<style scoped></style>
